function initCloseAlert() {
  $('.darken-overlay').one('click touchend',function() {
    $('.darken-overlay, .alert-box').fadeOut(400);
  });
}
